import React, { useEffect, useState } from "react";
import { ReactSession } from 'react-client-session';
import { useRef } from "react";
import axios from "axios";

export default function NewCuttingSchedule({ quote }) {
    // console.log("Rendering NewCuttingSchedule with quote:", quote);

  const urlParams = new URLSearchParams(window.location.search);
      const quoteIds = urlParams.get('id');
      const arrayValues = urlParams.get('arrayValues');
      const userId = ReactSession.get('upvcuserId');
      const useNumber = ReactSession.get('upvcNumber');
      const Address = ReactSession.get('upvcAddress');
      const Name = ReactSession.get('upvcuserName');
      const Image = ReactSession.get('upvcImage');
      const regid = ReactSession.get("upvcregid");
      const Empid = ReactSession.get("upvcempid");
      const userType = ReactSession.get("upvcuserType");
     const profileImage = quote?.quoteDetails[0]?.quoteData?.selectedProfile || 'profile_logo';
      
    let users='';
    if (userType === '3') {
      users =  Empid ;
    } else {
      users = userId ;
    }
    const user = { "userId": users };


  const [seriesData, setSeriesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [brandDatas, setBdata] = useState(null);



   const brandData = async () => {
      try {
        const response = await axios.get('https://upvcapi.sninfoserv.com/company/', {params: { userId: users }});
        //console.log(response.data);
        if(response.data.status === 'success'){
          setBdata(response.data.data);
          // setDes(response.data.data[0].companyTerms);
          // setBankName(response.data.data[0].companyBank);
          // setBranchName(response.data.data[0].companyBranch);
          // setAcHolderName(response.data.data[0].companyBankerName);
          // setAcType(response.data.data[0].companyBankType);
          // setAcNumber(response.data.data[0].companyAcNum);
          // setIfsc(response.data.data[0].companyIfsc);
        }
      } catch (error) {
        console.error('Error fetching brand data:', error);
      } 
    };
      
    useEffect(() => {
      brandData();
    },[]);

  // Convert measurements to mm
  function convertToMM(value, measure) {
    if (measure === "ft") return Number(value) * 304.8;
    if (measure === "inch") return Number(value) * 25.4;
    return Number(value);
  }

  // Map quote to input
 function mapQuoteToInput(quote = {}) {
  const data = quote.data || {};

  return {
    series: Number(quote.series?.replace(/\D/g, "")),
    shutterCount: Number(quote.shutterCount || 0),
	  FixedCount: Number(quote.fixedCount || 0),
    mesh: quote.mesh === "yes" ? "yes" : "no",
	  grill: quote.grill === "yes" ? "yes" : "no",
    bw: convertToMM(quote.boxWidth, quote.measure),
    bh: convertToMM(quote.boxHeight, quote.measure),
    qty: Number(quote.qty || 1),
    tfQty: Number(quote.topFixedNum || 0),
    bfQty: Number(quote.bottomFixedNum || 0),
    bfc: Number(quote.bottomnewHeights || 0),
    tfc: Number(quote.topnewHeights || 0),
    profile: quote.selectedProfile || "",
    item: quote.item || "",
    framename: data.frame?.name || "",
    Shuttername: data.shutter?.name || "",
    beedingname: data.beeding?.name || "",
    meshname: data.meshFrame?.name || "",
    mullionname: data.mullion?.name || "",
    glassname: data.glass?.name || "",
    interlockname: data.interlock?.name || "",
    Bottom:  Number(quote.bottomFrame || 0),
  };
}


  // API call to get cutting schedule
  const getCuttingSchedule = async (profile, item) => {
    try {
      const response = await axios.post(
        "https://upvcapi.sninfoserv.com/cuttingSchedule/",
        { profile, item }
      );
      const data = response.data?.data;
      return data && Array.isArray(data.calculations) ? data.calculations : [];
    } catch (err) {
      console.error("API error:", err);
      return [];
    }
  };

  // Fetch all seriesData from quote
  useEffect(() => {
    if (!quote?.quoteDetails?.length) return;

    async function fetchAllCalculations() {
      setLoading(true);
      const allSeriesData = [];

      for (const detail of quote.quoteDetails) {
        const input = mapQuoteToInput(detail.quoteData);
        const calculations = await getCuttingSchedule(input.profile, input.item);
        allSeriesData.push({ calculations });
      }

      setSeriesData(allSeriesData);
      setLoading(false);
    }

    fetchAllCalculations();
  }, [quote]);

  // WindowCalculator class for 1-to-1 mapping
  class WindowCalculator {
    constructor(seriesData) {
      this.seriesData = seriesData;
    }

    calculate({ series, shutterCount, mesh, bw, bh, qty, tfQty, bfQty, tfc, bfc,item, framename, Shuttername, beedingname, meshname, mullionname, glassname, Bottom,interlockname,grill,FixedCount }, windowIndex) {
      const meshKey = (mesh || "no").toLowerCase();

      // 1️⃣ Filter seriesData only by series
      let filteredSeries = [];
      this.seriesData.forEach(item => {
        const matched = item.calculations?.filter(calc => calc.series === series) || [];
        if (matched.length > 0) filteredSeries.push(...matched);
      });

      if (filteredSeries.length === 0) return null;


      // console.log("filteredSeries:", filteredSeries);

      // 2️⃣ Pick the series corresponding to window index
      const calc = filteredSeries[windowIndex % filteredSeries.length]; // fallback with modulo

      if (!calc) return null;

      const shutterConfig = calc.shutters?.[shutterCount+FixedCount]?.[meshKey] || {};

      const outerOffset = Number(shutterConfig.outerOffset || 0);
      const sashOffsetheight = Number(shutterConfig.sashOffsetheight || 0);
      const sashOffsetwidth = Number(shutterConfig.sashOffsetwidth || 0);
      const glassOffsetwidth = Number(shutterConfig.glassOffsetwidth || 0);
      const glassOffsetheight = Number(shutterConfig.glassOffsetheight || 0);
      const meshOffsetheight = Number(shutterConfig.meshOffsetheight || 0);
      const meshOffsetwidth = Number(shutterConfig.meshOffsetwidth || 0);
      const mullionOffset = Number(shutterConfig.mullionOffset || 0);
      const interlockoffset = Number(shutterConfig.interlockoffset || 0);
      const topFixedOffset = Number(shutterConfig.topFixedOffset || 0);
      const bottomFixedOffset = Number(shutterConfig.bottomFixedOffset || 0);
      const sashOffsetheightwithbottomoffset = Number(shutterConfig.sashOffsetheightwithbottom || 0);


     const outerHeight = bh- outerOffset;
    const sashHeight =
  Bottom === "no"
    ? (bh - tfc - bfc) - sashOffsetheight
    : (bh - tfc - bfc) - sashOffsetheightwithbottomoffset;
    // const sashHeight = (bh - tfc - bfc) - sashOffsetheight;
    const glassHeight = (bh - tfc - bfc) - sashOffsetheight - glassOffsetheight;
     const beedingHeight = (bh - tfc - bfc) - sashOffsetheight - 0;
    const meshHeight = meshKey === "yes" ? (bh - tfc - bfc) - meshOffsetheight : 0;
    const topFixedHeight = tfc - topFixedOffset;
    const bottomFixedHeight = bfc - bottomFixedOffset;
    const interlockHeight = (bh -meshOffsetheight- interlockoffset);

      const outerWidth = bw - outerOffset;
      const mullionLength = (bh - tfc - bfc) - mullionOffset;
     const topFixedWidth = bw - topFixedOffset;
    const bottomFixedWidth = bw - bottomFixedOffset;
    
      const sashWidth =
        shutterCount === 1 ? bw - sashOffsetwidth : bw / (shutterCount+FixedCount) - sashOffsetwidth;
      const glassWidth =
        shutterCount === 1
          ? bw - sashOffsetwidth - glassOffsetwidth
          : bw / (shutterCount+FixedCount) - sashOffsetwidth - glassOffsetwidth;
      const meshWidth =
        meshKey === "yes"
          ? shutterCount === 1
            ? bw - meshOffsetwidth
            : bw / (shutterCount+FixedCount) - meshOffsetwidth
          : 0;
          const beedingwidth = 
          shutterCount === 1
          ? bw - sashOffsetwidth - 0
          : bw / (shutterCount+FixedCount) - sashOffsetwidth - 0;

      return {
        outer: { width: outerWidth, widthQty: 2 * qty, height: outerHeight, heightQty: 2 * qty },
        sash: { width: sashWidth, widthQty: 2 * shutterCount * qty, height: sashHeight, heightQty: 2 * shutterCount * qty },
         mullion: {
             sash: {
             height: shutterCount -1 > 0 ? mullionLength : 0,
             reqQty: shutterCount -1
            },
            topFixed: {
              height: tfQty > 0 ? topFixedHeight : 0,
              heightQty: tfQty > 0 ? (tfQty-1) * qty : 0,
              width: tfQty > 0 ? topFixedWidth : 0,
              widthtQty: bfQty > 0 ? qty : 0
            },
            bottomFixed: {
              height: bfQty > 0 ? bottomFixedHeight : 0,
              heightQty: bfQty > 0 ? (bfQty-1) * qty : 0,
              width: bfQty > 0 ? bottomFixedWidth : 0,
              widthtQty: bfQty > 0 ? qty : 0
            }
         },
         beeding:{
          height:beedingHeight,
          width:beedingwidth,
          qty:(shutterCount+FixedCount) * qty
         },
        interlock:{
         height: interlockHeight,
        },
        meshPart: { width: meshWidth, widthQty: meshKey === "yes" ? 2 * shutterCount * qty : 0, height: meshHeight, heightQty: meshKey === "yes" ? 2 * shutterCount * qty : 0 },
        glass: { width: glassWidth, height: glassHeight, qty: (shutterCount+FixedCount) * qty },
        seriesId: calc.series,
        Qty:qty,
        frameName: framename,
        shutterName: Shuttername,
        beedingName: beedingname,
        meshName: meshname,
        mullionName: mullionname,
        glassName: glassname,
        interlockName: interlockname,
        item:item,
        boxwidth:bw,
        boxheight:bh,
        Shuttercount:shutterCount,
        FixedCount:FixedCount,
        TopFixed:tfQty,
        TopFixedheight:tfc,
        bottomFixed:bfQty,
        bottomFixedheight:bfc,
        mesh:mesh,
        Grill:grill
		
      };
    }
  }

  if (loading) return <p>Loading cutting schedule...</p>;

  const calculator = new WindowCalculator(seriesData);

  // Map each window to its series calculation based on window index
  const results = (quote?.quoteDetails || []).map((detail, idx) => {
    const input = mapQuoteToInput(detail.quoteData);
    const calculation = calculator.calculate(input, idx);
    return { idx, calculation };
  });

  const format = val => (typeof val === "number" ? val.toFixed(2) : val);

  return (
  <div>
  
    
	 <div class="modal fade custom-modal" id="onloadModals" tabindex="-1" aria-labelledby="onloadModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" align="center">
          <div class="mt-3 mb-3">
            <h5>Preparing Cutting Schedule...</h5>
          </div>
        </div>
      </div>
    </div>

    <div
      id="pdf-cutting-schedule"
      className="hide"
      style={{
        maxWidth: "207mm",
        minWidth: "207mm",
        padding: "20px"
      }}
    >

      {/* ================= HEADER TABLE ================= */}
      <table width="100%">
        <tbody>
          <tr>
            <td width="30%" style={{ textAlign: "left" }}>
              <img src="assets/images/saalaram.png" width="20%" alt="Logo" />
            </td>

            <td width="40%" style={{ textAlign: "center" }}>
              <img src={`assets/user/${brandDatas && brandDatas[0].companyLogo}`} height='50px' alt={brandDatas && brandDatas[0].companyLogo}
                width="30%"
              />
              <p>
                {brandDatas?.[0]?.companyName} <br />
                {brandDatas?.[0]?.companyAddress} <br />
                {brandDatas?.[0]?.companyContact}
              </p>
            </td>

            <td width="30%" style={{ textAlign: "right" }}>
              <img src={`assets/images/${profileImage}.jpg`} width="35%" alt="Logo" />
            </td>
          </tr>
        </tbody>
      </table>

      <hr />

      {/* ================= CLIENT INFO ================= */}
      <table width="100%">
        <tbody>
          <tr>
            <td width="50%">
              Client: {quote?.client?.name} <br />
              Location: {quote?.client?.location} <br />
              Contact: {quote?.client?.number}
            </td>
            <td width="50%" style={{ textAlign: "right" }}>
              Date: {quote?.date} <br />
              Quote No: {quote?.quoteId}
            </td>
          </tr>
        </tbody>
      </table>

      {/* ================= COLUMN HEADER ================= */}
      <table
        width="100%"
        style={{
          border: "1px solid #d4d4d4",
          borderCollapse: "collapse",
          tableLayout: "fixed"
        }}
      >
        <thead>
          <tr>
            <th width="5%" rowSpan={2} style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>S.No</th>
            <th width="16%" rowSpan={2} style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Model</th>
            <th width="5%" rowSpan={2} style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Qty</th>
            <th width="10%" rowSpan={2} style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Frame</th>
            <th rowSpan={2} style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Profile</th>
            <th width="15%" colSpan={2} style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Width</th>
            <th width="15%" colSpan={2} style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Height</th>
          </tr>

          <tr>
            <th style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Size</th>
            <th width="5%" style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Qty</th>
            <th width="10%"style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Size</th>
            <th style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Qty</th>
          </tr>

        </thead>
      </table>

      {/* ================= EACH ITEM BLOCK ================= */}
      {results?.map(({ calculation }, i) => {

        if (!calculation) return null;

        return (
          <table
            key={i}
            className="no-break"
            width="100%"
            style={{
              border: "1px solid #d4d4d4",
              borderCollapse: "collapse",
              tableLayout: "fixed",
              marginBottom: "0px",
            }}
          >
            <tbody>

              {/* FIRST ROW */}
              <tr>
                <td rowSpan={9} width="5%" style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>
                  {i + 1}
                </td>

                <td rowSpan={9} width="16%" style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>
                  <b>{calculation.item}</b><br />
                  {Number(calculation.boxwidth).toFixed(2)} x {Number(calculation.boxheight).toFixed(2)}<br/>
                  Specifications <br/>
                  Sash: {calculation.Shuttercount} <br/>
                  Fixed: {calculation.FixedCount} <br/>
                  Top Fixed: {calculation.TopFixed} <br/>
                  Bottom Fixed: {calculation.bottomFixed} <br/>
                  Mesh: {calculation.mesh} <br/>
                  Grill: {calculation.Grill}
                </td>

                <td rowSpan={9} width="5%" style={{ border: "1px solid #d4d4d4" }}>
                  {calculation.Qty}
                </td>

                <td width="10%" style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>Outer Frame</td>
                <td style={{ border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.frameName}</td>
                <td width="10%" style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.outer.width)}</td>
                <td width="5%" style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.outer.widthQty}</td>
                <td width="10%" style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.outer.height)}</td>
                <td width="5%" style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.outer.heightQty}</td>
              </tr>

              {/* SASH */}
              <tr>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>Sash</td>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>{calculation.shutterName}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.sash.width > 0 ? calculation.sash.width : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.sash.widthQty > 0 ? calculation.sash.widthQty : null}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}> {format(calculation.sash.height > 0 ? calculation.sash.height : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.sash.heightQty > 0 ? calculation.sash.heightQty : null}</td>
              </tr>

              {/* Beed */}
              <tr>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>Beeding</td>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>{calculation.beedingName}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.beeding.width > 0 ? calculation.beeding.width : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.beeding.qty > 0 ? calculation.beeding.qty : null}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.beeding.height > 0 ? calculation.beeding.height : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.beeding.qty > 0 ? calculation.beeding.qty : null}</td>
              </tr>

              {/* MESH */}
              <tr>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4", fontSize: "12px" }}>Mesh</td>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.meshName}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.meshPart.width > 0 ? calculation.meshPart.width : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.meshPart.widthQty > 0 ? calculation.meshPart.widthQty : null}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.meshPart.height > 0 ? calculation.meshPart.height : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.meshPart.heightQty > 0 ? calculation.meshPart.heightQty : null}</td>
              </tr>


              {/* Mullion */}
              <tr>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>Mullion</td>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>{calculation.mullionName}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}> </td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}></td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.mullion.sash.height)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.mullion.sash.reqQty}</td>
              </tr>


               {/* TopFixed */}
              <tr>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>Top Fixed</td>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>{calculation.mullionName}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}> {format(calculation.mullion.topFixed.width > 0 ? calculation.mullion.topFixed.width : null)} </td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4" }}> {calculation.mullion.topFixed.widthQty > 0 ? calculation.mullion.topFixed.widthQty : null}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.mullion.topFixed.height > 0 ? calculation.mullion.topFixed.height : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.mullion.topFixed.qty > 0 ? calculation.mullion.topFixed.qty : null}</td>
              </tr>


               {/* BottomFixed */}
              <tr>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>Bottom Fixed</td>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>{calculation.mullionName}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}> {format(calculation.mullion.bottomFixed.width > 0 ? calculation.mullion.bottomFixed.width : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4" }}> {calculation.mullion.bottomFixed.widthQty > 0 ? calculation.mullion.bottomFixed.widthQty : null}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.mullion.bottomFixed.height > 0 ? calculation.mullion.bottomFixed.height : null)} </td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.mullion.bottomFixed.qty > 0 ? calculation.mullion.bottomFixed.qty : null}</td>
              </tr>


              {/* Interlock */}
              <tr>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>Interlock</td>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>{calculation.interlockName}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.interlock.width > 0 ? calculation.interlock.width : null)}</td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.interlock.qty > 0 ? calculation.interlock.qty : null}</td>
                <td style={{ textAlign: "right", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.interlock.height > 0 ? calculation.interlock.height : null)} </td>
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.interlock.qty > 0 ? calculation.interlock.qty : null}</td>
              </tr>

              {/* GLASS */}
              <tr>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>Glass</td>
                <td style={{ padding: "6px", fontSize: "12px", border: "1px solid #d4d4d4" }}>{calculation.glassName}</td>
                <td colSpan={3}style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{format(calculation.glass.width > 0 ? calculation.glass.width : null)} x {format(calculation.glass.height > 0 ? calculation.glass.height : null)} </td>
                {/* <td style={{ textAlign: "center", border: "1px solid #d4d4d4" }}>{calculation.glass.qty > 0 ? calculation.glass.qty : null}</td> */}
                {/* <td style={{ border: "1px solid #d4d4d4" }}>{format(calculation.glass.height > 0 ? calculation.glass.height : null)}</td> */}
                <td style={{ textAlign: "center", border: "1px solid #d4d4d4", fontSize: "12px" }}>{calculation.glass.qty > 0 ? calculation.glass.qty : null}</td>
              </tr>

              {/* NOTES */}
              <tr>
                <td colSpan={9} style={{
                  border: "1px solid #d4d4d4",
                  padding: "10px",
                  paddingBottom: "60px"
                }}>
                  Notes
                </td>
              </tr>

            </tbody>
          </table>
        );
      })}

    </div>
</div>

  );
}
